'use client';

import React, { useState, useEffect } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';
import { useLanguage } from '@/contexts/LanguageContext';

interface CardData {
  id: string;
  title: string;
  price: string;
  people: string;
  image: string;
  alt: string;
  features: string[];
}

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHydrated, setIsHydrated] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const cards: CardData[] = [
  {
    id: 'promo-1',
    title: 'إعلان 1',
    price: '',
    people: '',
    image: "https://ocadeynpyrbhhpnmlizj.supabase.co/storage/v1/object/sign/123/WhatsApp%20Image%202026-07-23%20at%205.08.36%20PM%20(3).jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZDJlYmU2My03ZDcwLTQ1ODYtOWNhMC1mMWM2NjNiZjZkZDUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiIxMjMvV2hhdHNBcHAgSW1hZ2UgMjAyNi0wNy0yMyBhdCA1LjA4LjM2IFBNICgzKS5qcGVnIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4NDgxNTkwMiwiZXhwIjoxODE2MzUxOTAyfQ.iBLXuuo2c0mT563tjzO0YlvTRvUOPxERH8rgm0vFWsA",
    alt: 'إعلان إبداع الحرفة - عرض 1',
    features: []
  },
  {
    id: 'promo-2',
    title: 'إعلان 2',
    price: '',
    people: '',
    image: "https://ocadeynpyrbhhpnmlizj.supabase.co/storage/v1/object/sign/123/WhatsApp%20Image%202026-07-23%20at%205.08.36%20PM.jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZDJlYmU2My03ZDcwLTQ1ODYtOWNhMC1mMWM2NjNiZjZkZDUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiIxMjMvV2hhdHNBcHAgSW1hZ2UgMjAyNi0wNy0yMyBhdCA1LjA4LjM2IFBNLmpwZWciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzg0ODE1ODk1LCJleHAiOjE4MTYzNTE4OTV9.uRp4x7XIMeMW-9y2vGSC2byrMwhhccpUJi3vDpOT6iY",
    alt: 'إعلان إبداع الحرفة - عرض 2',
    features: []
  },
  {
    id: 'promo-3',
    title: 'إعلان 3',
    price: '',
    people: '',
    image: "https://ocadeynpyrbhhpnmlizj.supabase.co/storage/v1/object/sign/123/WhatsApp%20Image%202026-07-23%20at%205.08.37%20PM%20(3).jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZDJlYmU2My03ZDcwLTQ1ODYtOWNhMC1mMWM2NjNiZjZkZDUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiIxMjMvV2hhdHNBcHAgSW1hZ2UgMjAyNi0wNy0yMyBhdCA1LjA4LjM3IFBNICgzKS5qcGVnIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4NDgxNTg4NiwiZXhwIjoxODE2MzUxODg2fQ.BqiZ1vq3gq0UdgVlD1EtplvtLZlAyJWBP-sY98gG-zo",
    alt: 'إعلان إبداع الحرفة - عرض 3',
    features: []
  },
  {
    id: 'promo-4',
    title: 'إعلان 4',
    price: '',
    people: '',
    image: "https://ocadeynpyrbhhpnmlizj.supabase.co/storage/v1/object/sign/123/WhatsApp%20Image%202026-07-23%20at%205.08.36%20PM%20(1).jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZDJlYmU2My03ZDcwLTQ1ODYtOWNhMC1mMWM2NjNiZjZkZDUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiIxMjMvV2hhdHNBcHAgSW1hZ2UgMjAyNi0wNy0yMyBhdCA1LjA4LjM2IFBNICgxKS5qcGVnIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4NDgxNTg3NywiZXhwIjoxODE2MzUxODc3fQ.7kUeUDqGExZhKhUXXSV8i5zDV01Qfl_AvL7YSp_9efc",
    alt: 'إعلان إبداع الحرفة - عرض 4',
    features: []
  },
  {
    id: 'promo-5',
    title: 'إعلان 5',
    price: '',
    people: '',
    image: "https://ocadeynpyrbhhpnmlizj.supabase.co/storage/v1/object/sign/123/WhatsApp%20Image%202026-07-23%20at%205.08.37%20PM.jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZDJlYmU2My03ZDcwLTQ1ODYtOWNhMC1mMWM2NjNiZjZkZDUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiIxMjMvV2hhdHNBcHAgSW1hZ2UgMjAyNi0wNy0yMyBhdCA1LjA4LjM3IFBNLmpwZWciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzg0ODE1ODY4LCJleHAiOjE4MTYzNTE4Njh9.2EcXmZTAGmuFxdxqVIJoGNXyNicBza2lnpGbhcPv9E0",
    alt: 'إعلان إبداع الحرفة - عرض 5',
    features: []
  },
  {
    id: 'promo-6',
    title: 'إعلان 6',
    price: '',
    people: '',
    image: "https://ocadeynpyrbhhpnmlizj.supabase.co/storage/v1/object/sign/123/WhatsApp%20Image%202026-07-23%20at%205.08.35%20PM.jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZDJlYmU2My03ZDcwLTQ1ODYtOWNhMC1mMWM2NjNiZjZkZDUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiIxMjMvV2hhdHNBcHAgSW1hZ2UgMjAyNi0wNy0yMyBhdCA1LjA4LjM1IFBNLmpwZWciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzg0ODE1ODU4LCJleHAiOjE4MTYzNTE4NTh9.cGFw4Xk4nCcMuz50X1rjV6jxG1geAOBPgQDrhCeWKig",
    alt: 'إعلان إبداع الحرفة - عرض 6',
    features: []
  },
  {
    id: 'promo-7',
    title: 'إعلان 7',
    price: '',
    people: '',
    image: "https://ocadeynpyrbhhpnmlizj.supabase.co/storage/v1/object/sign/123/WhatsApp%20Image%202026-07-23%20at%205.08.36%20PM%20(2).jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZDJlYmU2My03ZDcwLTQ1ODYtOWNhMC1mMWM2NjNiZjZkZDUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiIxMjMvV2hhdHNBcHAgSW1hZ2UgMjAyNi0wNy0yMyBhdCA1LjA4LjM2IFBNICgyKS5qcGVnIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4NDgxNTg0NCwiZXhwIjoxODE2MzUxODQ0fQ.QJA_lfCBadlCskb-80JsS9uXDcfq1L6qJdDtPgyKhdo",
    alt: 'إعلان إبداع الحرفة - عرض 7',
    features: []
  },
  {
    id: 'promo-8',
    title: 'إعلان 8',
    price: '',
    people: '',
    image: "https://ocadeynpyrbhhpnmlizj.supabase.co/storage/v1/object/sign/123/WhatsApp%20Image%202026-07-23%20at%205.08.36%20PM%20(4).jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZDJlYmU2My03ZDcwLTQ1ODYtOWNhMC1mMWM2NjNiZjZkZDUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiIxMjMvV2hhdHNBcHAgSW1hZ2UgMjAyNi0wNy0yMyBhdCA1LjA4LjM2IFBNICg0KS5qcGVnIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4NDgxNTgzNCwiZXhwIjoxODE2MzUxODM0fQ.xlDq-a_UfQWfPoBf9S1v_DniQSeKrH8kGkzphfJz0lA",
    alt: 'إعلان إبداع الحرفة - عرض 8',
    features: []
  },
  {
    id: 'promo-9',
    title: 'إعلان 9',
    price: '',
    people: '',
    image: "https://ocadeynpyrbhhpnmlizj.supabase.co/storage/v1/object/sign/123/WhatsApp%20Image%202026-07-23%20at%205.08.37%20PM%20(2).jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZDJlYmU2My03ZDcwLTQ1ODYtOWNhMC1mMWM2NjNiZjZkZDUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiIxMjMvV2hhdHNBcHAgSW1hZ2UgMjAyNi0wNy0yMyBhdCA1LjA4LjM3IFBNICgyKS5qcGVnIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4NDgxNTgyNSwiZXhwIjoxODE2MzUxODI1fQ.eTZtEe1CUviYu9NTCj0tPQprpoNC0YEXrAYq30WTK3Q",
    alt: 'إعلان إبداع الحرفة - عرض 9',
    features: []
  },
  {
    id: 'promo-10',
    title: 'إعلان 10',
    price: '',
    people: '',
    image: "https://ocadeynpyrbhhpnmlizj.supabase.co/storage/v1/object/sign/123/WhatsApp%20Image%202026-07-23%20at%205.08.37%20PM%20(1).jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZDJlYmU2My03ZDcwLTQ1ODYtOWNhMC1mMWM2NjNiZjZkZDUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiIxMjMvV2hhdHNBcHAgSW1hZ2UgMjAyNi0wNy0yMyBhdCA1LjA4LjM3IFBNICgxKS5qcGVnIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4NDgxNTgxMSwiZXhwIjoxODE2MzUxODExfQ.u88HQohKzSAHnib8jhXhU9Tkq_I7ZI3hWDr4lpMpgRU",
    alt: 'إعلان إبداع الحرفة - عرض 10',
    features: []
  }];


  useEffect(() => {
    if (!isHydrated) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % cards.length);
    }, 7000);

    return () => clearInterval(interval);
  }, [isHydrated, cards.length]);

  const handleSlideChange = (index: number) => {
    setCurrentSlide(index);
  };

  if (!isHydrated) {
    return (
      <section className="relative bg-gradient-to-br from-primary via-secondary to-primary min-h-[600px] flex items-center justify-center">
        <div className="container mx-auto px-6">
          <div className="text-center text-white">
            <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
          </div>
        </div>
      </section>);

  }

  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-primary overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 py-10 lg:py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-12 items-center">
          {/* Text Content */}
          <div className="text-white space-y-3 lg:space-y-6">
            <h1 className="text-3xl lg:text-6xl font-bold font-amiri leading-tight">
              {t('وفّر أكثر مع بطاقات الاشتراك المميزة', 'Save More with Premium Subscription Cards')}
            </h1>
            <p className="text-base lg:text-2xl opacity-90 leading-relaxed">
              {t('احصل على خصومات حصرية تصل إلى 50% في أكثر من 50+ شريك تجاري', 'Get exclusive discounts up to 50% at 50+ business partners')}
            </p>
            <div className="flex flex-wrap gap-3 pt-2 lg:pt-4">
              <Link
                href="/subscription-cards"
                className="inline-flex items-center gap-2 px-5 py-3 lg:px-8 lg:py-4 bg-accent text-accent-foreground rounded-lg font-bold text-sm lg:text-lg transition-premium hover:bg-accent/90 hover:shadow-xl active-press">
                <Icon name="CreditCardIcon" size={20} />
                <span>{t('اشترك الآن', 'Subscribe Now')}</span>
              </Link>
              <Link
                href="/partners-network"
                className="inline-flex items-center gap-2 px-5 py-3 lg:px-8 lg:py-4 bg-white/10 text-white rounded-lg font-bold text-sm lg:text-lg transition-premium hover:bg-white/20 backdrop-blur-sm">
                <Icon name="BuildingStorefrontIcon" size={20} />
                <span>{t('تصفح الشركاء', 'Browse Partners')}</span>
              </Link>
            </div>
          </div>

          {/* Card Slider */}
          <div className="relative">
            <div className="relative aspect-[3/2] rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-gray-900 to-gray-800 p-4 lg:p-6">
              {cards.map((card, index) =>
              <div
                key={card.id}
                className={`absolute inset-0 transition-all duration-1000 flex items-center justify-center p-4 lg:p-6 ${
                currentSlide === index ?
                'opacity-100 scale-100' : 'opacity-0 scale-95'}`
                }>
                  <AppImage
                  src={card.image}
                  alt={card.alt}
                  className="w-full h-full object-contain" />
                </div>
              )}
            </div>

            {/* Slide Indicators */}
            <div className="flex justify-center gap-2 mt-3 lg:mt-6">
              {cards.map((_, index) =>
              <button
                key={index}
                onClick={() => handleSlideChange(index)}
                className={`w-2 h-2 lg:w-3 lg:h-3 rounded-full transition-premium ${
                currentSlide === index ?
                'bg-accent w-8 lg:w-12' : 'bg-white/40 hover:bg-white/60'}`
                }
                aria-label={`الانتقال إلى الشريحة ${index + 1}`} />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;